const Director = 'Director'
const Manager = 'Manager'
const Analyst = 'Analyst'
const SalesExecutive = 'SalesExecutive'
const Financial = "Financial"

const depotsRegisterRoutes = [
  {
    path: '/modalities/create',
    name: 'ModalityRegister',
    params: {
      solution: 'retail'
    },
    meta: { 
      auth: true,
      roles: [Director],
    },
    component: () => import('@/_backoffice/_registrations/components/modality/CreateModality.vue')
  },
  {
    path: '/modalities_wholesale/create',
    name: 'ModalityRegisterWholesale',
    params: {
      solution: 'wholesale'
    },
    meta: { 
      auth: true,
      roles: [Director],
    },
    component: () => import('@/_backoffice/_registrations/components/modality/CreateModality.vue')
  },

  {
    path: '/modalities',
    name: 'ModalityList',
    meta: { 
      auth: true,
      roles: [Director],
    },
    params: {
      solution: 'wholesale'
    },
    component: () => import('@/_backoffice/_registrations/pages/Modality.vue'),
    children:[
      {
        path: ':id',
        name: 'ShowModalityRegister',
        meta: { 
          auth: true ,
          roles: [Director],
        },
        component: () => import('@/_backoffice/_registrations/components/modality/ShowModalityRegister.vue'),
      },
    ]
  },
  {
    path: '/modalities_wholesale',
    name: 'ModalityListWholesale',
    meta: { 
      auth: true,
      roles: [Director],
    },
    params: {
      solution: 'wholesale'
    },
    component: () => import('@/_backoffice/_registrations/pages/Modality.vue'),
    children:[
      {
        path: ':id',
        name: 'ShowModalityRegisterWholesale',
        meta: { 
          auth: true ,
          roles: [Director],
        },
        params:{
          solution: 'wholesale'
        },
        component: () => import('@/_backoffice/_registrations/components/modality/ShowModalityRegister.vue'),
      },
    ]
  },

]


export default depotsRegisterRoutes